function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ismobile from 'is-mobile';
var watermark = typeof document !== 'undefined' ? require('watermarkjs') : null;

var ImagePreview = function ImagePreview(_ref) {
  var authorName = _ref.authorName,
      preview = _ref.preview,
      siteUrlPrefix = _ref.siteUrlPrefix;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      imageSet = _useState2[1];

  var watermarkOptions = {
    init: function init(img) {
      img.crossOrigin = 'anonymous';
    }
  };
  var watermarkImage = 'https://tes-resources-thumbnails-development.s3-eu-west-1.amazonaws.com/_watermark/tes-watermark.png';
  var brokenImage = 'https://image.flaticon.com/icons/svg/63/63422.svg'; // Enable for text watermark
  // const copyrightText = `Copyright author ${authorName}`;
  // const copyrightStyle = '18px Verdana';
  // const copyrightColor = '#8B0000';
  // const copyrightAlpha = 1;

  function generateWatermark() {
    return _generateWatermark.apply(this, arguments);
  }

  function _generateWatermark() {
    _generateWatermark = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ref2, _ref3, firstImage, firstImageURL, imageEl;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!preview.pages || !preview.pages.length)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", imageSet({
                src: brokenImage
              }));

            case 2:
              _ref2 = preview.pages || [], _ref3 = _slicedToArray(_ref2, 1), firstImage = _ref3[0];
              firstImageURL = (firstImage || {}).url;

              if (!watermark) {
                _context.next = 16;
                break;
              }

              _context.prev = 5;
              _context.next = 8;
              return watermark([firstImageURL, watermarkImage], watermarkOptions).image(watermark.image.center(0.5));

            case 8:
              imageEl = _context.sent;
              return _context.abrupt("return", imageSet(imageEl));

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              console.error('Error displaying thumbnail:', _context.t0);
              return _context.abrupt("return", imageSet({
                src: brokenImage
              }));

            case 16:
              return _context.abrupt("return", imageSet({
                src: brokenImage
              }));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }));
    return _generateWatermark.apply(this, arguments);
  }

  useEffect(function () {
    generateWatermark();
  }, []);
  var isMobile = ismobile();
  var previewClasses = classNames({
    'mobile-previewBox': isMobile,
    'previewBox': !isMobile // eslint-disable-line quote-props

  });
  return /*#__PURE__*/React.createElement("div", {
    className: "preview-context"
  }, /*#__PURE__*/React.createElement("div", {
    className: previewClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "viewport"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "preview",
    src: image.src || ''
  })))), /*#__PURE__*/React.createElement("p", {
    className: "preview-author"
  }, "Resource author:", /*#__PURE__*/React.createElement("a", {
    href: "".concat(siteUrlPrefix, "/teaching-resources/shop/").concat(encodeURIComponent(authorName)),
    className: "preview-author__link"
  }, authorName)));
};

ImagePreview.displayName = "ImagePreview";
export default ImagePreview;
ImagePreview.propTypes = {
  authorName: PropTypes.string,
  preview: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  siteUrlPrefix: PropTypes.string
};
ImagePreview.defaultProps = {
  authorName: 'NAIS',
  preview: {
    dimensions: {
      width: 500,
      height: 500
    },
    pages: [{
      url: 'https://tes-resources-thumbnails-development.s3-eu-west-1.amazonaws.com/025f793bea9e6e80284abe3379914fa87c44781a/025f793bea9e6e80284abe3379914fa87c44781a-thumbnail-500x500.png'
    }]
  },
  siteUrlPrefix: ''
};